import { IRegisterManagerInjectable } from '@src/slide/application/service/register-manager/inject/register-manager.interface';
import SocketListener, { ISocketListener } from '@src/slide/application/service/register-manager/core/listeners/socket-listener';
import PersistentListener from '@src/slide/application/service/register-manager/core/listeners/persistent-listener';
import { CollaborationListener } from '@src/slide/application/service/register-manager/core/listeners/collaboration-listener';
import RevisionListener from '@src/slide/application/service/register-manager/core/listeners/revision-listener';
import { MutationListener } from '../listeners/mutation-listener';

export default class RegisterManager {
    private persistentListener: PersistentListener;
    private socketListener: ISocketListener;

    public constructor(private injectable: IRegisterManagerInjectable) {
        // socket 响应
        this.socketListener = new SocketListener(
            this.injectable.shouldListenSocketChange,
            this.injectable.shouldListenSocketCommitUpload,
        );
        // 数据恢复SlideApp监听
        this.persistentListener = new PersistentListener(this.socketListener);
        // pc RevisionListener 注册
        new RevisionListener(this.socketListener);

        new CollaborationListener();

        new MutationListener();
    }

    /**
     * 事件监听移除
     */
    public dispose() {
        this.persistentListener.unregisterBeforeunload();
    }
}
